// Customer-authorized support access ("lockbox"). Grants are plain Firestore
// rows under the org (rules: admins create, owner-only for "until revoked",
// the only edit is revocation); the operator-side console talks to the
// backend /support/* routes, which refuse anything no active grant covers.
import { db } from '../firebaseConfig';
import { idToken } from './orgs';

const API = (process.env.REACT_APP_UPLOAD_API || '').replace(/\/+$/, '');

export const GRANT_LEVEL_LABEL = {
  org: 'Whole organization',
  project: 'One project',
  document: 'One document',
  conversation: 'One AI conversation',
};

export const GRANT_DURATIONS = [
  { id: '48h', label: '48 hours (default)', ms: 48 * 3600 * 1000 },
  { id: '7d', label: '7 days', ms: 7 * 24 * 3600 * 1000 },
  { id: '30d', label: '30 days', ms: 30 * 24 * 3600 * 1000 },
  { id: 'never', label: 'Until revoked (owner only)', ms: null },
];

export const grantIsActive = (g, now = Date.now()) => !g.revokedAt && (g.expiresAt == null || g.expiresAt > now);

export async function createAccessGrant(orgId, user, { level, dealId = null, docId = null, sessionId = null, label = '', reason, durationMs }) {
  const now = Date.now();
  const ref = db.collection(`orgs/${orgId}/accessGrants`).doc();
  await ref.set({
    level,
    dealId: dealId || null,
    docId: docId || null,
    sessionId: sessionId || null,
    label: label || '',
    grantedTo: 'fast.legal support',
    reason: reason.trim(),
    grantedBy: user.uid,
    grantedByName: user.displayName || (user.email || '').split('@')[0] || '',
    grantedByEmail: user.email || '',
    expiresAt: durationMs == null ? null : now + durationMs,
    revokedAt: null,
    revokedBy: null,
    createdAt: now,
  });
  return ref.id;
}

export async function revokeAccessGrant(orgId, grantId, user) {
  await db.doc(`orgs/${orgId}/accessGrants/${grantId}`).update({ revokedAt: Date.now(), revokedBy: user.uid });
}

// ---- Operator console (superadmin) ---------------------------------------
async function call(path) {
  if (!API) throw new Error('Backend API not configured');
  const token = await idToken();
  const res = await fetch(`${API}${path}`, { headers: { Authorization: `Bearer ${token}` } });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `${path} failed (${res.status})`);
  return data;
}
export const supportListGrants = () => call('/support/grants').then((d) => d.grants || []);
export const supportOpenGrant = (orgId, grantId) => call(`/support/grants/${orgId}/${grantId}`);
export const supportOpenDoc = (orgId, grantId, dealId, docId) => call(`/support/grants/${orgId}/${grantId}/docs/${dealId}/${docId}`);
export const supportOpenSession = (orgId, grantId, sessionId) => call(`/support/grants/${orgId}/${grantId}/sessions/${sessionId}`);
